module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "x-button",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "min-height": "calc(95vh - 141px)"
    }
  }, [_vm._t("body", [_c('div', [_c('md-table', [_c('md-table-row', [_c('md-table-head', [_vm._v("EDITED BY")]), _vm._v(" "), _c('md-table-head', [_vm._v("DATE")])], 1), _vm._v(" "), (_vm.articleHistory.length > 0) ? _vm._l((_vm.articleHistory), function(item, key) {
    return _c('md-table-row', {
      key: key
    }, [_c('md-table-cell', [_vm._v(_vm._s(item.editedBy.user))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(_vm._f("moment")(_vm.$moment(item.editedBy.timestamp * 1000), "hh:mm DD/MM/YYYY")))]), _vm._v(" "), _c('md-table-cell', [_c('button', {
      on: {
        "click": function($event) {
          _vm.restore(item)
        }
      }
    }, [_vm._v("RESTORE")])])], 1)
  }) : _vm._e()], 2)], 1)])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("Done")])])], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c9713f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/history.vue
// module id = 625
// module chunks = 1